import React from 'react';
import { InvoiceTemplateProps } from './types';
import Header from './primitives/Header';
import InvoiceTitle from './primitives/Title';
import PatientInfo from './primitives/PatientInfo';
import InvoiceDetails from './primitives/InvoiceDetails';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template1_A4WithHeader({ invoice, hospital }: InvoiceTemplateProps) {
  return (
    <div 
      className="invoice-root bg-white p-8 max-w-[210mm] mx-auto" 
      style={{ 
        minHeight: '297mm',
        fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
      }}
    >
      <Header hospital={hospital} showLogo={true} variant="centered" />
      <InvoiceTitle />

      <div className="grid grid-cols-2 gap-8 mb-3">
        <PatientInfo invoice={invoice} layout="column" />
        <InvoiceDetails invoice={invoice} />
      </div>
      
      <ItemsTable items={invoice.items} variant="standard" headerColor="bg-blue-600" />
      
      <Totals invoice={invoice} layout="standard" showPaymentInfo={true} />
      
      <Footer variant="signature" notes={invoice.notes} />
    </div>
  );
}
